// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/logs',
    name: 'logs-user',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/logs/Index.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'logs_user',
    },
  },
]

export default formTable
